(ns practitest.frontend.global-fields-settings.entity-linker
  (:require
    [practitest.frontend.forms3.entity-form.fields :as fields3]
    [practitest.frontend.common.i18n :refer [get-translation]]
    [reagent.core :as r]
  ))


(def ^:private rows
  [{:type :entity
    :id :test
    :name (get-translation "test.singular" "Test")
    :input-type "checkbox"}

   {:type :entity
    :id :requirement
    :name (get-translation "requirement.singular" "Requirement")
    :input-type "checkbox"}

   {:type :entity
    :id :issue
    :name (get-translation "issue.singular" "Issue")
    :input-type "checkbox"}

   {:type :entity
    :id :milestone
    :name (get-translation "milestone.singular" "Milestone")
    :input-type "checkbox"}

   {:type :subtitle
    :label (get-translation "testset.grid.title" "TestSets & Runs")}

   {:type :none-radio
    :id :none
    :name (get-translation "generic.label.none" "None")
    :input-type "radio"}

   {:type :entity
    :id :testSets
    :name (get-translation "testset.singular" "TestSet")
    :input-type "radio"}

   {:type :entity
    :id :instances
    :name (get-translation "instance.singular" "Instance")
    :input-type "radio"}

   {:type :entity
    :id :run
    :name (get-translation "testset.button.run" "Run")
    :input-type "radio"}])

(defn- boolean-input [{:keys [type checked disabled on-change name]}]
  [:input {:type type
           :name name
           :checked checked
           :disabled disabled
           :class (if (= type "checkbox") "m-checkbox" "custom-radio-input")
           :on-change #(on-change (.. % -target -checked))}])

(defn- update-linked [table-data current-id input-type is-checked?]
  (cond
    (= input-type "checkbox")
    (assoc-in table-data [current-id :linked] is-checked?)

    (= input-type "radio")
    (let [radio-rows (filter #(and (= "radio" (:input-type %))
                                   (= :entity (:type %))) rows)]
      (reduce
        (fn [acc {:keys [id]}]
          (assoc-in acc [id :linked] (= id current-id)))
        table-data
        radio-rows))))

(defn- table-entity-row [{:keys [id name input-type]} table-data change-value field-type]
 (let [link-entity? (boolean (get-in table-data [id :linked]))]
   ;; entity type
   [:tr
    [:td.entity-type
     [boolean-input
      {:type input-type
       :checked link-entity?
       :disabled false
       :on-change (fn [is-checked?] (change-value (update-linked table-data id input-type is-checked?)))
       :name "entity-type"}]
     [:span name]]
   ;; mandatory
    [:td.mandatory-check
     (when (not= field-type "checkbox")
      [boolean-input
       {:type "checkbox"
        :checked (get-in table-data [id :mandatory])
        :disabled (not link-entity?)
        :on-change (fn [is-checked?] (change-value (assoc-in table-data [id :mandatory] is-checked?)))}])]]))

(defn- subtitle-row [{:keys [label]}]
  [:tr.subtitle
   [:td {:col-span 2}
    label]])

(defn- none-radio-row [{:keys [id name input-type]} table-data change-value]
  (let [any-entity-linked? (some #(get-in table-data [(:id %) :linked])
                                   (filter #(and (= "radio" (:input-type %))
                                                 (= :entity (:type %))) rows))]
  [:tr
   [:td.entity-type {:col-span 2}
     [boolean-input
      {:type input-type
       :name "entity-type"
       :checked (not any-entity-linked?)
       :on-change (fn [is-checked?] (change-value (update-linked table-data id input-type is-checked?)))}]
     [:span name]]]))

(defn entity-linker-table [table-id form-props]
  (let [{:keys [get-field-state set-field-state]} form-props
        table-data (or (:value @(get-field-state table-id)) {})
        change-value (fn [new-value]
                       (set-field-state table-id {:value new-value
                                                  :dirty? true}))
        available? (:value @(get-field-state :global-field-select-projects))
        field-type (:value @(get-field-state :global-field-format))]
    [:table {:class (str "new-grid " "global-entity-linker" (when (not available?) " disabled"))}
     [:thead
      [:tr
       [:th (get-translation "generic.label.entity-type" "Entity type")]
       [:th (get-translation "generic.label.mandatory" "Mandatory")]]]
     [:tbody
      (for [row rows]
         (case (:type row)
           :entity
           ^{:key (:id row)}
           [table-entity-row row table-data change-value field-type]

           :subtitle
           ^{:key (:label row)}
           [subtitle-row row]

           :none-radio
           ^{:key (:id row)}
           [none-radio-row row table-data change-value]))]]))